/**
 * DataObject (Information Pillar) Validation Schemas
 */

import { z } from 'zod';
import { nameField, optionalBoundedText, optionalUrlField } from './shared';

export const createDataObjectSchema = z.object({
  name: nameField(
    200,
    'Data object name is required',
    'Data object name must be less than 200 characters'
  ),
  description: optionalBoundedText(1000, 'Description must be less than 1000 characters'),
  objectType: z.enum(['entity', 'event', 'aggregate', 'document', 'report', 'reference'], {
    message: 'Object type is required',
  }),
  classification: z.enum(['public', 'internal', 'confidential', 'restricted'], {
    message: 'Classification is required',
  }),
  containsPII: z.boolean().optional().default(false),
  containsPCI: z.boolean().optional().default(false),
  containsPHI: z.boolean().optional().default(false),
  encryptionRequired: z.boolean().optional().default(false),
  maskingRequired: z.boolean().optional().default(false),
  systemOfRecord: z.string().optional(),
  isGoldenRecord: z.boolean().optional().default(false),
  lifecycleStatus: z.enum(['planned', 'developing', 'active', 'mature', 'deprecated', 'retired'], {
    message: 'Lifecycle status is required',
  }),
  retentionPeriodDays: z.number().int().positive().optional(),
  tags: z.array(z.string()).optional(),
  notes: z.string().optional(),
  documentationUrl: optionalUrlField('Documentation URL must be a valid URL'),
});

export type CreateDataObjectFormData = z.infer<typeof createDataObjectSchema>;
